import { Injectable } from '@angular/core';
import { ISupportScriptService } from './support-script-service.interface';

@Injectable({ providedIn: 'root' })
export abstract class BaseSupportScriptService implements ISupportScriptService {
    public abstract readonly scriptIdentifier: string;

    public abstract loadScript<T>(data: T): void;

    public unloadScript(): void {
        const scripts = document.querySelectorAll(`script[data-script-identifier="${ this.scriptIdentifier }"]`);
        scripts.forEach(script => {
            script.parentNode.removeChild(script);
        });
    }
}
